import { HiddenFieldType } from '../../questionType';

import HiddenField from './components/HiddenField';

const HiddenFieldElement = {
  [HiddenFieldType.TEXT]: HiddenField,
};

export default HiddenFieldElement;
